<script>
import FormModel from "@/views/Edms/Template/Components/FormModel.vue";
export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        archiveAction: Boolean,
        unarchiveAction: Boolean,
    },
    components: {FormModel}
}
</script>

<template>
    <FormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        :archive-action="archiveAction"
        :unarchive-action="unarchiveAction"
        type="CONTENT"
    />
</template>